import { render } from "./StudiesDashboard.vue?vue&type=template&id=7a1214d2"
import script from "./StudiesDashboard.vue?vue&type=script&lang=js"
export * from "./StudiesDashboard.vue?vue&type=script&lang=js"

import "./StudiesDashboard.vue?vue&type=style&index=0&id=7a1214d2&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/DACY_Demo_Server/kbdemo_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__